/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TodoTemplate } from '../../models/todo-template';
import { UpdateTodoTemplateRequest } from '../../models/update-todo-template-request';

export interface UpdateTodoTemplate$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: UpdateTodoTemplateRequest
}

export function updateTodoTemplate(http: HttpClient, rootUrl: string, params: UpdateTodoTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<TodoTemplate>> {
  const rb = new RequestBuilder(rootUrl, updateTodoTemplate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TodoTemplate>;
    })
  );
}

updateTodoTemplate.PATH = '/api/v1/todo_templates/{id}';
